import EventAgent from '@hotmart/event-agent-js'

import { DATA_VERSION, EVENT_VERSION } from './constants'
import { System, type SendEventParams } from './types'

const isProd = process.env.NODE_ENV === 'production'

EventAgent.mode = isProd ? 'production' : 'staging'

class DataHubService {
  static sendEvent({
    schema,
    dataVersion = DATA_VERSION,
    eventVersion = EVENT_VERSION,
    system = System.MEMBERSHIP_COMMUNITY
  }: SendEventParams): void {
    const dataHubEvent = {
      system,
      action: schema.action,
      entity: schema.entity,
      data_version: dataVersion,
      event_version: eventVersion,
      event: schema.getDataHubEventData()
    }

    if (!isProd) {
      console.log('Datahub event dispatched: ', dataHubEvent)
    }

    EventAgent.send(dataHubEvent)
  }
}

export default DataHubService
